import { TableColumnsType } from "ant-design-vue";

export const leadsResumeColumns: TableColumnsType = [
  {
    title: "Campaña",
    dataIndex: "portfolio",
  },
  {
    title: "Secuencia",
    dataIndex: "sequence",
  },
  {
    title: "Cantidad de leads",
    dataIndex: "total_leads",
  },
  {
    title: "N° leads tipificados",
    dataIndex: "lead_typified",
  },
  {
    title: "N° leads sin gestionar",
    dataIndex: "lead_not_typified",
  },
];
